import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-profile-outlet',
    templateUrl: './profile-outlet.component.html',
    styleUrls: ['./profile-outlet.component.scss'],
    standalone: true,
    imports: [RouterOutlet]
})
export class ProfileOutletComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
